import { hbs } from 'ember-cli-htmlbars';
export default hbs('<div class=\"o--blank o--blank--full\">\n  <h2>{{t \"app.error\"}}</h2>\n  <h3><a href=\"/\">{{t \"app.home\"}}</a></h3>\n</div>', { moduleName: 'later/templates/error.hbs' });
